import { useId } from 'react';

import { Stack } from '@lyearn/ui';

import BoxRadioButton from './components/BoxRadioButton';
import TextRadioButton from './components/TextRadioButton';
import { RadioButtonTypes, RadioGroupProps } from './types';

const RadioButtonConfig: {
  [key in RadioButtonTypes]: typeof BoxRadioButton;
} = {
  box: BoxRadioButton,
  text: TextRadioButton,
};

const RadioGroup = <T = string,>({
  direction = 'col',
  gap = 12,
  options,
  type,
  size = 'default',
  selectedId,
  onChange,
  name,
  className,
  overrides,
  buttonStyleOverrides,
}: RadioGroupProps<T>) => {
  const RadioButton = RadioButtonConfig[type];
  const _name = useId();

  return (
    <Stack className={className} direction={direction} gap={gap} role="radiogroup">
      {options.map((option, index) => {
        return (
          <RadioButton
            key={index}
            isSelected={option.id === selectedId}
            name={name ?? _name}
            option={option}
            size={size}
            styleOverrides={buttonStyleOverrides}
            onChange={onChange}
            {...(overrides?.radioButtonProps ?? {})}
          />
        );
      })}
    </Stack>
  );
};

export default RadioGroup;
